<template>
  <v-container class="d-flex justify-center">
    <v-card
      class="confirm-check-in-sheet__card rounded-xl"
      width="950"
      height="600"
    >
      <v-container>
        <v-row justify="end">
          <v-col>
            <v-icon
              class="confirm-check-in-sheet__back"
              v-if="!isAdmin"
              @click="$router.push({ name: 'single-check-in-sheet', params: { id } })"
            >
              mdi-chevron-left
            </v-icon>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-icon
              class="confirm-check-in-sheet__close"
              @click="$router.push({ name: 'check-in-sheets' })"
              >mdi-close</v-icon
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="isAdmin" class="ml-5">
            <v-list
              width="auto"
              max-width="400"
              height="400"
              class="ma-2 overflow-y-auto check-in-sheet__converter_codes"
            >
              <p class="text-h5 font-weight-black ml-5">Order List</p>
              <v-list-item
                :key="converter.code"
                v-for="converter in converters"
              >
                <v-list-item-content>
                  <v-list-item-title class="font-weight-black">
                    {{ converter.code }}
                  </v-list-item-title>
                  <span class="text-caption"
                    >Quantity: {{ converter.quantity }}
                    {{ converter.quantity > 1 ? "pcs" : "pc" }}</span
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col>
            <v-card
              class="ma-2 mt-4 rounded-xl check-in-sheet__confirmation"
              elevation="0"
              height="400"
              width="auto"
              max-width="400"
              color="#F5F5F5"
            >
              <v-card-title class="text-h5 justify-center font-weight-black"
                >Totals</v-card-title
              >
              <v-card-text>
                <p class="font-weight-black">
                  Total Items: {{ currentCheckInSheet.total_items }}
                </p>
                <p class="font-weight-black">
                  Average Converter Price: ${{
                    currentCheckInSheet.avg_converter_price
                  }}
                </p>
                <p class="font-weight-black">
                  Subtotal: ${{ currentCheckInSheet.subtotal }}
                </p>
                <p class="font-weight-black">
                  HST: ${{ currentCheckInSheet.hst }}
                </p>
                <p class="font-weight-black text-h6">TOTAL: ${{ total }}</p>
              </v-card-text>
              <v-card-actions
                v-if="isAdmin"
                class="d-flex flex-column justify-center"
              >
                <v-btn @click="download" class="green white--text" elevation="0"
                  >download</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="isAdmin" style="margin: 0px">
          <v-col cols="6" class="d-flex justify-center">
            <v-btn
              color="#524F4F"
              @click="$router.push({ name: 'single-check-in-sheet', params: { id } })"
              class="white--text"
              elevation="0"
              >edit order</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import {
  mapState as checkInSheetMapState,
  mapActions as checkInSheetMapActions,
} from "@/store/modules/checkInSheet";
import { mapGetters as userMapGetters } from "@/store/modules/user";

export default {
  name: "ConfirmCheckInSheet",
  props: {
    id: String,
  },
  mounted() {
    if (this.converters.length === 0) {
      this.fetchCheckInSheet(this.id);
    }
  },
  computed: {
    ...checkInSheetMapState(["converters", "currentCheckInSheet"]),
    total() {
      return (
        this.currentCheckInSheet.subtotal + this.currentCheckInSheet.hst
      ).toFixed(2);
    },
    ...userMapGetters(["isAdmin"]),
  },
  methods: {
    ...checkInSheetMapActions(["setConverterList", "fetchCheckInSheet"]),
    async download() {
      const response = await window.axios({
        url: "/api/sheet/download/" + this.id,
        method: "POST",
        responseType: "blob",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(response.data);
      link.download =
        response.headers["content-disposition"].substr(
          22,
          response.headers["content-disposition"].length - 1
        ) + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-check-in-sheet__title {
  display: flex;
  position: absolute;
  right: 20px;
  top: 10px;
  .confirm-check-in-sheet__close {
    justify-content: flex-end;
  }
  confirm-check-in-sheet__back {
    justify-content: start;
  }
}
</style>
